import { CHANGE_LANGUAGE } from "./InternationalizationActions";

const internationalizationReducer = (state = { activeLangCode: localStorage.getItem('activeLangCode') ? localStorage.getItem('activeLangCode') : 'en' }, action) => {
    switch (action.type) {
        case CHANGE_LANGUAGE:
            localStorage.setItem('activeLangCode', action.langCode)
            return {
                ...state,
                activeLangCode: action.langCode
            }
        default:
            return state
    }
}

export default internationalizationReducer


// WEBPACK FOOTER //
// ./src/features/common/internationalization/InternationalizationReducer.js